module.exports = __webpack_public_path__ + "images/saaremaa/apple-icon-114x114.png";